export default __webpack_public_path__ + "static/media/Version (6) - Ultimate Map_03.1fdb1d1a.jpg";